// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioCs {
    fecha={}
    lista=[
        {
            encabezado:"1. Información personal y laboral",
            datos:[
                {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
                {valor:"", descripcion:"", tipo:1 ,label:"b. En su trabajo realiza movimientos repetitivos frecuentemente:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"c. Si la respuesta es afirmativa, indicar la parte del cuerpo:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Manos ",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Brazos (codos, hombros)",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Cuello ",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Espalda (Tronco)",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Miembros inferiores",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. En su trabajo adopta posiciones forzadas frecuentemente:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"e. Si la respuesta es afirmativa, indicar la parte del cuerpo:" },
                {valor:"", descripcion:"", tipo:1 ,label:"Manos ",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Brazos (codos, hombros)",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Cuello ",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Espalda (Tronco)",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Miembros inferiores",data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. En su trabajo realiza empuje-arrastre de cargas frecuentemente:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. En su trabajo realiza levantamiento de cargas frecuentemente:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. En su trabajo realiza transporte de cargas manualmente de manera frecuente:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"i. En su trabajo realiza movilización de personas manualmente de manera frecuente:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"j. En su trabajo realiza aplicación de fuerza (presionar, mover piezas):",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"k. Pasa la mayor parte del tiempo en posición sentado:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"l. Exposición extralaboral (EEL) frecuentemente:" },
                {valor:"", descripcion:"", tipo:1 ,label:"     i. Movimiento repetitivo:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     ii. Postura forzada",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     iii. Levantamiento manual de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     iv. Transporte manual de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     v. Empuje y tracción de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     vi. Aplicación de fuerza:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"m. Exposición trabajos anteriores (ETA) frecuentemente:" },
                {valor:"", descripcion:"", tipo:1 ,label:"     i. Movimiento repetitivo:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     ii. Postura forzada",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     iii. Levantamiento manual de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     iv. Transporte manual de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     v. Empuje y tracción de cargas:",data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"     vi. Aplicación de fuerza:",data:["SI","NO"]},
            ]
        },
        {
            encabezado:"2. Antecedentes de trastornos musculoesqueléticos",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Fracturas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Esguinces" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Mialgias" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Artralgias" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Neuritis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Artritis/artrosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Enfermedades degenerativas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Otros" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      Especificar:"},
                {valor:"", descripcion:"", tipo:1 ,label:"i. Estudios y tratamientos recibidos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      Especificar:"},
            ]
        },
        {
            encabezado:"3. Antecedentes patológicos generales (HCU)",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"Hipertensión arterial" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Diabetes" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Otras metabólicas y degenerativas" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Mentales" ,data:["SI","NO"]},
            ]
        },
        {
            encabezado:"4. Antecedentes de familiares cercanos (padre-madre-hermanos) con patología musculoesquelética",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"a. Artritis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      ¿Quiénes?:"},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Artrosis" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      ¿Quiénes?:"},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Trastornos musculares degenerativos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      ¿Quiénes?:"},
                {valor:"", descripcion:"", tipo:1 ,label:"d. Trastornos neurológicos (centrales o periféricos)" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"      ¿Quiénes?:"},
            ]
        },
        {
            encabezado:"5. Sintomatología actual",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Dolor:" },
                {valor:"", descripcion:"", tipo:1 ,label:"    En manos:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    En miembros superiores" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    En cuello:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    En la espalda:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    En miembros inferiores:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:3 ,label:"    Irradiación del dolor (se mantiene en la zona de origen o sigue trayectoria a otra zona):" },
                {valor:"", descripcion:"", tipo:3 ,label:"    Forma de comienzo (insidioso, brusco):" },
                {valor:"", descripcion:"", tipo:3 ,label:"    Evolución del dolor (agudo o cronico):" },
                {valor:"", descripcion:"", tipo:3 ,label:"    Factores desencadenantes o agravantes del dolor:" },
                {valor:"", descripcion:"", tipo:1 ,label:"    Intensidad del dolor:" ,data:["Leve","Moderado","Intenso","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    El dolor desaparece o disminuye cuando deja de trabajar:" ,data:["SI","NO","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    Relación del dolor con los tratamientos:" ,data:["Mejora","Empeora","No se modifica","N/A"]},
                {valor:"", descripcion:"", tipo:1 ,label:"b. Alguna molestia en la espalda alta o baja (sensación de peso, cansancio):" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Parestesias (hormigueo):" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"    ubicación:" },
                {valor:"", descripcion:"", tipo:3 ,label:"    frecuencia:" },
                {valor:"", descripcion:"", tipo:1 ,label:"d. Debilidad (pérdida de la fuerza):" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"e. Palidez en las manos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"f. Trastornos del sueño:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"g. Alteraciones de carácter:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"h. Nerviosismo:" ,data:["SI","NO"]},
            ]
        },
        {
            encabezado:"6. Exploración física",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Inspección:" },
                {valor:"", descripcion:"", tipo:0 ,label:"    i. En la columna:" },
                {valor:"", descripcion:"", tipo:1 ,label:"          cifosis " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"          lordosis " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"          escoliosis " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"          gibosidad costal " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"          tortícolis " ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    ii. Contornos articulares" ,data:["Normales","Con deformidad"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    iii. Extremidades con atrofias" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    iv. Extremidades con cicatrices" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    v. Extremidades con amputaciones" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    vi. Extremidades con tumefacción en los dedos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    vii. Extremidades con desviaciones de los dedos" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:0 ,label:"b. A la palpación y/o percusión:" },
                {valor:"", descripcion:"", tipo:1 ,label:"    puntos anatómicos dolorosos:" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"    Ubicación:" },
                {valor:"", descripcion:"", tipo:1 ,label:"c. Conclusión:" ,data:["Normal","Anormal"]},
            ]
        },
        {
            encabezado:"7. Exploración funcional",
            datos:[
                {valor:"", descripcion:"", tipo:0 ,label:"a. Exploración de la movilidad activa y pasiva:" },
                {valor:"", descripcion:"", tipo:1 ,label:"    i. Función de pinza (pulgar-índice)" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    ii. Cadera y muslo (flexión):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    iii. Cadera y muslo (extensión).:" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    iv. Cadera y muslo (abducción):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    v. Cadera y muslo (aducción).:" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    vi. Cadera y muslo (rotación interna):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    vii. Cadera y muslo (rotación externa).:" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    viii. Rodillas (flexión):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    ix. Rodillas (extensión):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    x. Tobillo (flexión dorsal):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xi. Tobillo (flexión plantar):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xii. Tobillo (inversión subastragalina):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xiii. Tobillo (eversión subastragalina):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xiv. Pie (flexión):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xv. Pie (extensión):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xvi. Pie (abducción):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xvii. Pie (aducción):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xviii. Pie (rotación interna):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"    xix. Pie (rotación externa):" ,data:["Normal","Anormal"]},
                {valor:"", descripcion:"", tipo:1 ,label:"c. Conclusión:" ,data:["Normal","Anormal"]},
            ]
        },
        {
            encabezado:"8. Ha recibido capacitaciones sobre los trastornos musculoesqueléticos (TME)...",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"procedimientos de trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"uso de herramientas y maquinaria" ,data:["Frecuentemente","Rara vez","Nunca"]},
                {valor:"", descripcion:"", tipo:1 ,label:"uso de los equipos de protección y otros relacionados con la salud y el trabajo" ,data:["Frecuentemente","Rara vez","Nunca"]},
            ]
        },
        {
            encabezado:"9. Aplicación del cuestionario nórdico (Kuorinka)",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Resultado" },
            ]
        },
        {
            encabezado:"10. Aplicación del cuestionario NDI (Vernon Mior)",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Resultado" },
            ]
        },
        {
            encabezado:"11. Aplicación del cuestionario Quick DASH",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Resultado" },
            ]
        },
        {
            encabezado:"12. Aplicación del cuestionario Roland Morris",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Resultado" },
            ]
        },
        {
            encabezado:"13. Uso de elemento de protección EPP",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"" ,data:["SI","NO"]},
            ]
        },
        {
            encabezado:"14. Conclusiones del estado de salud musculoesquelético",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
        {
            encabezado:"15. Recomendaciones en el campo de la salud musculoesquelético.",
            datos:[
                {valor:"", descripcion:"", tipo:4 ,label:"" },
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoMusculoEsqueleticoCs.js